export default [
  {
    title: 'Storage',
    gjIcon: 'Record',
    children: [
      {
        title: 'Analytics',
        route: 'storage-requests-analytics',
      },
      {
        title: 'Buckets',
        route: 'buckets',
      },
      {
        title: 'External Accounts',
        route: 'external-accounts',
      },
    ],
  },
]
